import HundredBricksAPI from '@lib/hundredBricksAPI/HundredBricksAPI';
import { APIError } from '@lib/api';
import AddressProofFileExtensionIsInvalid from '../AddressProofFileExtensionIsInvalid';
import AddressProofFileIsEmpty from '../AddressProofFileIsEmpty';
import AddressProofFileIsMissing from '../AddressProofFileIsMissing';
import AddressProofFileSizeIsExceeded from '../AddressProofFileSizeIsExceeded';
import FormAddressData from '../FormAddressData';
import InvestorHasInvalidState from '../InvestorHasInvalidState';
import InvestorNotFound from '../InvestorNotFound';
import InvestorProfile from '../../InvestorProfile';
import uploadAddressProofErrorHandler from '../uploadAddressProofErrorHandler';
import InvestorDoesNotHavePendingCorrections from '../InvestorDoesNotHavePendingCorrections';
import AddressProofError from './AddressProofError';
import AddressProofFileIsUnsupported from './AddressProofFileIsUnsupported';
import InvalidAddressProofStatus from './InvalidAddressProofStatus';
import ThereIsNoAddressProofToCorrect from './ThereIsNoAddressProofToCorrect';
class AddressProofAPI extends HundredBricksAPI {
    async uploadAddressProof(params) {
        const { proofFile, proofType } = params;
        try {
            const formData = new FormData();
            formData.append('file', proofFile);
            formData.append('type', proofType);
            const { data } = await this.client.post('v2/profile/addressProof', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
            return new InvestorProfile(data);
        }
        catch (error) {
            if (error instanceof APIError) {
                switch (error.code) {
                    case 'EMPTY_FILE':
                        throw new AddressProofFileIsEmpty({ cause: error });
                    case 'FILE_MISSING':
                        throw new AddressProofFileIsMissing({ cause: error });
                    case 'INCORRECT_FILE_EXTENSION':
                        throw new AddressProofFileExtensionIsInvalid({ cause: error });
                    case 'MAXIMUM_FILE_SIZE_EXCEEDED':
                        throw new AddressProofFileSizeIsExceeded({ cause: error });
                    case 'UNSUPPORTED_ADDRESS_PROOF':
                        throw new AddressProofFileIsUnsupported({ cause: error });
                    default:
                        throw new AddressProofError({ cause: error });
                }
            }
            else if (error instanceof Error) {
                throw new AddressProofError('Unexpected error when uploading address proof', { cause: error });
            }
            else {
                throw new AddressProofError(`Unexpected error when uploading address proof: '${error}'`);
            }
        }
    }
    async correctAddressProof(params) {
        const { proofFile, proofType } = params;
        try {
            const formData = new FormData();
            formData.append('file', proofFile);
            formData.append('type', proofType);
            const { data } = await this.client.post('v2/profile/addressProof/correct', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
            return new InvestorProfile(data);
        }
        catch (error) {
            if (error instanceof APIError) {
                switch (error.code) {
                    case 'INVESTOR_DOES_NOT_HAVE_PENDING_CORRECTIONS':
                        throw new InvestorDoesNotHavePendingCorrections({ cause: error });
                    case 'THERE_IS_NO_ADDRESS_PROOF_TO_CORRECT':
                        throw new ThereIsNoAddressProofToCorrect({ cause: error });
                    case 'INVALID_ADDRESS_PROOF_STATUS':
                        throw new InvalidAddressProofStatus({ cause: error });
                    case 'INVESTOR_INVALID_STATE':
                        throw new InvestorHasInvalidState({ cause: error });
                    default:
                        uploadAddressProofErrorHandler(error);
                }
            }
            if (error instanceof Error) {
                throw new AddressProofError('Unexpected error on correcting address proof', { cause: error });
            }
            throw new AddressProofError(`Unexpected error on correcting address proof: '${error}'`);
        }
    }
    async renewAddressProof(payload) {
        const { proofFile, proofType, ...address } = payload;
        try {
            const formData = new FormAddressData(address);
            formData.append('proofFile', proofFile);
            formData.append('proofType', proofType);
            const { data } = await this.client.post('v2/profile/addressProof/renew', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
            return new InvestorProfile(data);
        }
        catch (error) {
            if (error instanceof APIError) {
                switch (error.code) {
                    case 'INVALID_FILE_EXTENSION':
                        throw new AddressProofFileExtensionIsInvalid({ cause: error });
                    case 'INVESTOR_NOT_FOUND':
                        throw new InvestorNotFound({ cause: error });
                    case 'INVESTOR_DOES_NOT_HAVE_PENDING_CORRECTIONS':
                        throw new InvestorDoesNotHavePendingCorrections({ cause: error });
                    case 'INVESTOR_INVALID_STATE':
                        throw new InvestorHasInvalidState({ cause: error });
                    default:
                        uploadAddressProofErrorHandler(error);
                }
            }
            if (error instanceof Error) {
                throw new AddressProofError('Unexpected error on renewing address proof', { cause: error });
            }
            throw new AddressProofError(`Unexpected error on renewing address proof: '${error}'`);
        }
    }
}
export default AddressProofAPI;
